import { lazyRouteComponent } from "@tanstack/react-router";



const Feedback = lazyRouteComponent(() => import("./feedback.view"), "Feedback");

export const routeOptions = {
  component: Feedback,
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({
    token: typeof s.token === "string" ? s.token : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Lämna betyg – Alkoholprovet" },
      { name: "description", content: "Berätta hur det gick på kunskapsprovet och vad du tyckte om Alkoholprovet." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
};
